import dayjs from 'dayjs';
import stores from '@ganaderia/stores';
import useTime from './useTime';

export default () => {
  const time = useTime();

  const getAges = () => {
    const months: { title: string; value: number }[] = [];
    for (let i = 0.01; i <= 0.11; i += 0.01) {
      months.push({ title: `${Math.round(i * 100)} ${i === 0.01 ? 'mes' : 'meses'}`, value: i });
    }
    const years: { title: string; value: number }[] = [];
    for (let i = 1; i <= 15; i++) {
      years.push({ title: `${i} ${i === 1 ? 'año' : 'años'}`, value: i });
    }
    return months.concat(years);
  };

  const getPregnantSinces = () => {
    const months: { title: string; value: number }[] = [{ title: 'Vacia', value: 0 }];
    for (let i = 0; i <= 20; i += 0.5) {
      months.push({ title: `${i} ${i === 1 ? 'mes' : 'meses'}`, value: i });
    }
    return months;
  };

  const getIrons = () => {
    const mains = [
      'Sin',
      'AGP',
      'AGP-GB',
      'AGB-REY',
      'CPL',
      'm73',
      'm74',
      'm74-%58',
      'm74-PAB',
      'm74-PB',
      'PAB',
      'PAB-RA',
      'PB',
      'PB-AGP',
      'PB-C1V',
      'PB-REY',
      'TA73'
    ];
    return mains.map((hierro) => ({ title: hierro, value: hierro === 'Sin' ? null : hierro }));
  };

  const getMaxAge = () => Math.max(...getAges().map((a) => a.value));
  const getMinAge = () => Math.min(...getAges().map((a) => a.value));
  const getMinPregnantSince = () => Math.min(...getPregnantSinces().map((p) => p.value));
  const getMaxPregnantSince = () => Math.max(...getPregnantSinces().map((p) => p.value));

  const addPregnantSinceAndAge = <T extends { pregnancyDate: string; birthDate: string }>(
    cows: T[]
  ) => {
    return cows.map((cow) => ({
      ...cow,
      pregnantSince: time.getPregnantSince(cow.pregnancyDate),
      age: time.getAge(cow.birthDate)
    }));
  };

  const getFertilities = () => [
    { title: 'Becerro', value: 'becerro' },
    { title: 'Levante', value: 'levante' },
    { title: 'Vaca', value: 'vaca' },
    { title: 'Descarte', value: 'descarte' },
    { title: 'Macho', value: 'macho', disabled: true }
  ];

  const getGenders = () => [
    { title: 'Hembra', value: 'female' },
    { title: 'Macho', value: 'male' }
  ];

  const getGender = (female: boolean) => (female ? 'female' : 'male');

  const getColor = (date: string) => {
    const ageInMonth = dayjs().diff(dayjs(date, 'YYYY-MM-DD'), 'month');
    return ageInMonth > 7;
  };

  const getMonthText = (pregnantSince: number) => {
    if (pregnantSince === 0) return 'Vacia';
    if (pregnantSince < 0) return 'Error';
    return `${pregnantSince} ${pregnantSince === 1 ? 'mes' : 'meses'}`;
  };

  const getAgeText = (age: number) => {
    if (age < 1) return `${Math.round(age * 100)} ${age === 0.01 ? 'mes' : 'meses'}`;
    return `${age} ${age === 1 ? 'año' : 'años'}`;
  };

  const getRaceName = (item: { race_id?: number | null }) =>
    stores.auth.state.account.value?.races.find((r) => r.id === item.race_id)?.name;

  const getIronName = (item: { iron_id?: number | null }) =>
    stores.auth.state.account.value?.irons.find((i) => i.id === item.iron_id)?.name;

  const getFarmName = (item: { farm_id?: number | null }) =>
    stores.auth.state.account.value?.farms.find((f) => f.id === item.farm_id)?.name;

  return {
    getAges,
    getPregnantSinces,
    getIrons,
    getMaxAge,
    getMinAge,
    getMinPregnantSince,
    getMaxPregnantSince,
    addPregnantSinceAndAge,
    getFertilities,
    getGenders,
    getGender,
    getColor,
    getMonthText,
    getAgeText,
    getRaceName,
    getIronName,
    getFarmName
  };
};
